import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LinkingBetweenComponentsService {
  private trigger: boolean;
  private trigger$: Subject<boolean>;

  constructor() {
    this.trigger = true;
    this.trigger$ = new Subject();

  }

  sendTrigger(trigger: boolean) {
    this.trigger = trigger;
    this.trigger$.next(this.trigger);
  }
  getTrigger(): Observable<boolean> {
    return this.trigger$.asObservable();
  }


}
